<div id="tender-index-analysis" class="container-fluid mt-5">
  <div class="card bg-white mb-3">

    <div class="row align-items-center">
      <div class="col d-flex flex-row align-items-center min-height border-bottom">
        <h1 class="page-title mx-3">
          Index Analytics
        </h1>
        <ul class="nav nav-links ms-6">
        <jft-round-controls [tender]="tender" [round]="round" (onRoundChange)="roundChanged($event)" [rounds]="rounds"
        [contract]="contract">
        </jft-round-controls>
          <li class="nav-item">
            <a class="nav-link"
              [routerLink]="['/tenders',tender.id,'locations',contract.id,'dashboard','index-analysis','graph']"
              routerLinkActive="active">
              Index Graph
            </a>
          </li>
          <li class="nav-item">
                        <a class="nav-link"
                           [routerLink]="['/tenders',tender.id,'locations',contract.id,'dashboard','index-analysis','list']"
                           routerLinkActive="active">
                            Index List
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"
                            [routerLink]="['/tenders',tender.id,'locations',contract.id,'dashboard','index-analysis','year-on-year']"
                            routerLinkActive="active">
                            Year On Year
                        </a>
                    </li>
        </ul>
      </div>

    </div>
    <router-outlet></router-outlet>
  </div>
</div>
